module.exports = "/_next/static/images/om-b6771181ffa23699d31f5087041547ba.svg";